import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TabPosition, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountSummary, RelationAccount } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { AddressSummary } from '~/models/modules/address';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { GDataService } from '~/services/GDataService';

@Component({
    selector: 'address-edit-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksAddressesUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _theme: string;
  // _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _listbarcodegenerator: Array<any> = [];
  _isAutoGeneratingNumber: boolean;

  _invalidForm: boolean;
  _model: AddressSummary = null;
  _addressesCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _customFields: CustomFieldSummary[][] = [];
  _page: string = 'addresses';
  _permissionScope = 'addresses';
  _customTabs: any;
  _customFieldsValue: any = [];
  _selectedAccountIds: any[] = [];
  _selectedLabelId: number;
  _customFieldsDictionary: { [key: string]: string } = {};
  _language: string = 'en';
  _gridFieldText: GridFieldTextSummary[];
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _SINActive: boolean = true;
  _LOCActive: boolean = false;

  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;

  _requiredFieldNames: Array<any> = [];
  _requiredFields: Array<any> = [];
  _showEnterpriseCharts = false;

  _isEditForms: boolean = false;


  _stockItemGridColumns: GridFieldSummary[];

  openStockItemAddressForm: boolean = false;

  stockItemAddressChartDetail: StartEndDateChartResponseModel;
  stockItemAddressChart: Chart;
  stockItemAddressSecondChart: Chart;


  reactivate: boolean = false;
  reactivateItem: any;
  copyModelId: number;
  _customValidation: any = [];
  _customRequiredFields: Array<any> = [];
  _additionalErrors: any = [];

  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  QtyItemInAddressByDate: any;
  QtyLocationsInAddressByDate: any;

  AddressInfoSystemFields: Array<any> = [
    { title: 'AddressLine1' },
    { title: 'AddressLine2' },
    { title: 'AddressCity' },
    { title: 'AddressState' },
    { title: 'AddressZip' },
    { title: 'AddressCountry' },
    { title: 'AddressPhone1' },
    { title: 'AddressPhone2' },
    { title: 'AddressEmail' },
    { title: 'AddressWebsite' },
    { title: 'AddressFax' }
  ];

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Address_Name') kendoBarcodeGenAddressName: ElementRef;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  reloadlist: any;

  long: number;
  lat: number;


  isStockItemNumberGridExpanded: boolean = true;
  isStockItemNumberChartExpanded: boolean = true;

  zoom = 12;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };

  markers: any;

  constructor(private _layoutManager: LayoutManagerService,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _addressesService: AddressesService,
    private _fb: FormBuilder,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    private _stockItemsService: StockItemsService,
    private _dataService: GDataService,
    private _sharedService: SharedService) {
    super();
    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.applyOverly();

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.addressAccounts ?? []).map(
        (x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
      this._tabEnabled = this._selectedAccounts.length > 0;
    }

    this._currentUser = this._securityService.currentUser;

    this.loadLabels();

    this._customFieldsService.getDeactivatedCustomFields('stock').subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });

    if (this._model.id != null) {
      this._addressesService.getQtyItemInAddressByDate(this._model.id).subscribe((x: any) => {
        this.QtyItemInAddressByDate = x;
      });

      this._addressesService.getQtyLocationsInAddressByDate(this._model.id).subscribe((x: any) => {
        this.QtyLocationsInAddressByDate = x;
      });
    }
    //this.loadCustomFields(this._model.id?.toString());
    if (this._pageState == 2) {
      this.long = 13.367347745368066;
      this.lat = -19.90934476502726;
      this._LOCActive = true
    }
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.name = null;
    }

    if (this._model && this._model.id) {
      this.LoadUnitOfMeasureChart();

      if (this._model.long && this._model.lat) {
        this.long = +this._model.long;
        this.lat = +this._model.lat;
      }
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this._initForm();
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }

    // navigator.geolocation.getCurrentPosition((position) => {
    //   this.center = {
    //     lat: position.coords.latitude,
    //     lng: position.coords.longitude,
    //   };
    // });

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenAddressName.nativeElement.focus();
      }, 500);
    }

    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this.getAuth();
    this._viewInactiveFormTabs(true);
    //this.setMandatoryFields();
  }

  zoomIn() {
    if (this.zoom < this.options.maxZoom) {
      this.zoom++;
    }
  }

  zoomOut() {
    if (this.zoom > this.options.minZoom) {
      this.zoom--;
    }
  }

  mapClicked(event: any /*google.maps.MouseEvent*/) {
  }

  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat + ((Math.random() - 0.5) * 2) / 10,
        lng: this.center.lng + ((Math.random() - 0.5) * 2) / 10,
      },
      label: {
        color: 'red',
        text: 'Marker label ' + (this.markers.length + 1),
      },
      title: 'Marker title ' + (this.markers.length + 1),
      options: { animation: google.maps.Animation.BOUNCE },
    });
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _SINTabClick() {
    this._SINActive = true;
    this._LOCActive = false;
  }

  _LOCTabClick() {
    this._SINActive = false;
    this._LOCActive = true;
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  async LoadUnitOfMeasureChart() {
    this._addressesService.GetStockItemByAddressChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.stockItemAddressChartDetail = data;
      this.stockItemAddressChart = this.stockItemAddressChartDetail.chart;
      this.stockItemAddressSecondChart = this.stockItemAddressChartDetail.secondChart;
    });

    this._gridFields.getGridFieldsByPage('stockItems').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
      this._stockItemGridColumns = data;
    });
  }

  _getStockItemByAddress = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemAddressChartDetail.startDate,
      endDate: this.stockItemAddressChartDetail.endDate
    }
    return this._stockItemsService.GetStockItemByAddressId(this._model.id, startEndDate);
  }

  StockItemAddressChartOnActive(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.openStockItemAddressForm = true;
  }

  StockItemAddressChartOnClose() {
    this.openStockItemAddressForm = false;
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {

      this._pageState = PageState.EDIT_FIELDS;

    } else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = false;
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = false;
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }
  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _barcodeSubmited() {
    this._addressesCode.setValue(this._form.get('name').value);
    if (this._pageState == PageState.ADD) {
      this._addClassActive = true;
    }
  }
  _onFocusAddressName() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
    }
  }
  _onFocusOutAddressName() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = true;
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._addressesCode.setValue(data.result.toString());
        this._form.patchValue({
          name: data.result.toString()
        });
        if (this._pageState == PageState.ADD) {
          this._addClassActive = true;
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('addresses', quantity);
  }
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.warn(event);
    this._innerWidth = window.innerWidth;
    console.warn('window resize:' + this._innerWidth);
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() { }

  _onCancel() {

    this._closeForm(this._sharedService.model.reload != undefined ? this.modelupdatedlookup : '');
  }

  submodel: any;

  _closeForm(listmodel: any = null) {
    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;
    var closeComponent = {
      component: 'addresses',
      isClosed: true,
      response: this.reloadlist === undefined ? null : listmodel,
      addressData: listmodel
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('addresses');
    this._layoutManager.setFromChanged('addresses');
    this.ngOnDestroy();
    // this._addressesService.addressFormClosed(this._form.get('name').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    this._dataService.push(closeComponent);
    if (this.submodel === null)
      this._sharedService.model = {};

  }


  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  private _initForm() {
    this._form = this._fb.group({
      name: [this._model && this._model.name, Validators.required],
      addressLine1: [this._model && this._model.addressLine1, this.getLabel('LBL_AddressLine1')?.isRequired ? Validators.required : null],
      addressLine2: [this._model && this._model.addressLine2, this.getLabel('LBL_AddressLine2')?.isRequired ? Validators.required : null],
      city: [this._model && this._model.city, this.getLabel('LBL_AddressCity')?.isRequired ? Validators.required : null],
      state: [this._model && this._model.state, this.getLabel('LBL_AddressState')?.isRequired ? Validators.required : null],
      zip: [this._model && this._model.zip, this.getLabel('LBL_AddressZip')?.isRequired ? Validators.required : null],
      country: [this._model && this._model.country, this.getLabel('LBL_AddressCountry')?.isRequired ? Validators.required : null],
      phone1: [this._model && this._model.phone1, this.getLabel('LBL_AddressPhone1')?.isRequired ? Validators.required : null],
      phone2: [this._model && this._model.phone2, this.getLabel('LBL_AddressPhone2')?.isRequired ? Validators.required : null],
      fax: [this._model && this._model.fax, this.getLabel('LBL_AddressFax')?.isRequired ? Validators.required : null],
      website: [this._model && this._model.website, this.getLabel('LBL_AddressWebsite')?.isRequired ? Validators.required : null],
      email: [this._model && this._model.email, this.getLabel('LBL_AddressEmail')?.isRequired ? Validators.required : null],
      lat: [this._model && this._model.lat, this.getLabel('LBL_lat')?.isRequired ? Validators.required : null],
      long: [this._model && this._model.long, this.getLabel('LBL_long')?.isRequired ? Validators.required : null],
    });
  }
  modelupdatedlookup: any;

  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.'
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } //else if (this._custominvalidForm && this._customValidation.find((x: any) => !x.value) )
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        //const entries = Object.entries(this._customFieldsValue);

        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });

      }

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountIds'] = this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c));
      if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
        this._addressesService
          .updateAddress(this._model.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.id = this._model.id;
                  this._addressesService.AddressUpdated.emit(model);
                  if (e === 'saveAndClose') {
                    model.id = response.responseId;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this.copyModelId = this._model.id;
                    this._form.controls.name.setValue(null);
                    this._pageState = PageState.ADD;
                    this.loadCustomFields();
                  }
                  else if (e === 'saveAndNew') {
                    this.openUpsert(this._page, {}, PageState.ADD);
                    //this._closeForm();
                  }
                  else if (e === 'save') {
                    this._model.id = response.responseId;
                    this._pageState = PageState.EDIT;
                  }

                } else {
                  return;
                }
              }
            }
          });
      } else {
        this._addressesService
          .createAddress(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              if (!this._currentUser.isEnterprise) {
                this.note.createNote(response.responseId);
              }
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {

                if (response['close'] == true) {
                  model.id = response.responseId;
                  this._addressesService.AddressAdded.emit(model);
                  if (e === 'saveAndClose' || this.reloadlist != undefined) {
                    model.id = response.responseId;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.name.setValue(null);
                  }
                  else if (e === 'saveAndNew') {
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }

                  else if (e === 'save' || this.reloadlist != undefined) {
                    model.id = response.responseId;
                    this._model.id = response.responseId;
                    //this.modelupdatedlookup = model ;
                    this._pageState = PageState.EDIT;


                  }
                } else {
                  return;
                }
              }
            }

          });
      }
    }
  }

  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });

  }
  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  // _customFieldsValueChanges(customFieldsValue: any=[], tabId: number) {
  //       Object.keys(customFieldsValue).forEach((key) => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }

  //     if (
  //       this._customFields[tabId].find((x) => x.name == key).entityId == undefined ||
  //       this._customFields[tabId].find((x) => x.name == key).customFieldsData.length == 0
  //     ) {
  //       //new mode, custom field data not added yet
  //       this._customFields[tabId].find((x) => x.name == key).entityId = -1;
  //       this._customFields[tabId]
  //         .find((x) => x.name == key)
  //         .customFieldsData.push({ id: -1, value: 'null', entityId: -1,customFieldId:-1 });
  //     }
  //     var customFieldData = this._customFields[tabId]
  //       .find((x) => x.name == key)
  //       .customFieldsData.find(
  //         (x) =>
  //           x.entityId ==
  //           this._customFields[tabId].find((x) => x.name == key).entityId
  //       );
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;


  // }
  //#region  _customFieldsValueChanges
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }
  //#endregion
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'addresses' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             this.getFormTabs();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });

  // }

  private loadLabels() {
    //this._pacer.start();
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      })
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {


      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }



  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      })
  }


  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;

        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      })
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element))
    });

    this._systemFields.find(x => x.id === oldLocData.id).formOrder
      = sysFClone.find(x => x.id === newLocData.id).formOrder;
    this._systemFields.find(x => x.id === newLocData.id).formOrder
      = sysFClone.find(x => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      })
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      })
  }
  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }
  requiredSystemTabs: any = [];
  setMandatoryFields() {

    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (
          item.gridFieldText?.isRequired &&
          item.page?.trimEnd('') == this._page
        ) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger.nativeElement.querySelector('ul');


      Array.from(tabElementList.children).forEach((child: any) => {

        child.classList.remove('mendatoryTab');
      });


      Array.from(tabElementList.children).forEach((child: any) => {
        if (child.firstChild.innerText == 'General') {
          child.classList.add('mendatoryTab');
        }
        if (child.firstChild.innerText == 'Costing') {
          child.classList.add('mendatoryTab');
        }
        if (
          this._requiredFieldNames.find(
            (x) =>
              x.name === child.firstChild.innerText &&
              (x.page
                ? x.page.trimEnd('') == this._page
                : x.formTab.page.trimEnd('') == this._page)
          )
        ) {
          child.classList.add('mendatoryTab');
        }
        if (
          this.requiredSystemTabs.find(
            (x: any) =>
              x.name === child.firstChild.innerText
          )
        ) {
          child.classList.add('mendatoryTab');
        }
      });


      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }


  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState }
  }

  _closeDialog(event: boolean) {
    this._isDialiog = event;
  }


  getStockItemLeadsString(stockItemLeads: any) {
    let leads = '';
    let counter = 0;
    stockItemLeads.forEach((element: any) => {
      if (counter > 0) {
        leads += ', ';
      }
      leads += element.stockitemleadtime;
      counter++;
    });
    return leads;
  }

  getStockImage(stockItemFiles: any) {
    let files = '';
    let counter = 0;
    stockItemFiles.forEach((element: any) => {
      if (counter > 0) {
        files += ', ';
      }
      files += element.file.thumbnail;
      counter++;
    });
    return files;
  }

  getCategoryImage(categoryFiles: any) {
    let catfiles = '';
    let counter = 0;
    categoryFiles.forEach((element: any) => {
      if (counter > 0) {
        catfiles += ', ';
      }
      catfiles += element.file.thumbnail;
      counter++;
    });
    return catfiles;
  }

  getVendors(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.vendorid;
      counter++;
    });
    return vendor;
  }

  getTimeUnitCode(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockItemLeadid;
      counter++;
    });
    return vendor;
  }

  getTimeUnit(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockitemleadinterval;
      counter++;
    });
    return vendor;
  }



  getSitesString(accountSites: any, isId: boolean) {
    let sites = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        sites += ', ';
      }
      if (!isId) {
        if (element.site) {
          sites += element.site.name;
        } else {
          sites += 'All Sites';
        }
      }
      else {
        if (element.site) {
          sites += element.site.id;
        }
      }

      counter++;
    });
    return sites;
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }



  ExpandCollapseStockItemNumberGrid(isExpand: boolean) {
    this.isStockItemNumberGridExpanded = !isExpand;
  }


  ExpandCollapseStockItemNumberChart(isExpand: boolean) {
    this.isStockItemNumberChartExpanded = !isExpand;
  }
  ClickOnMap(e: any) {
  }
  markerClick(e: any) {
    this._form.controls.lat.setValue(e.latLng.lat());
    this._form.controls.long.setValue(e.latLng.lng());
  }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
}
